import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useQuery from '../../../../../hooks/useQuery';
import SelectBookingNavigation from './components/bookingNavigationTypes/SelectBookingNavigation';
import AutoBookingNavigation from './components/bookingNavigationTypes/AutoBookingNavigation';
import BookBookingNavigation from './components/bookingNavigationTypes/BookBookingNavigation';
import CompleteStatementBookingNavigation from './components/bookingNavigationTypes/CompleteStatementBookingNavigation';
import BookingTimer from '../BookingTimer';

function BookingNavigation({ outline = true }) {
  const query = useQuery();
  const seatFormation = query.get('seatFormation');
  const navigate = useNavigate();

  const navigationTypes = {
    select: SelectBookingNavigation,
    auto: AutoBookingNavigation,
    book: BookBookingNavigation,
    completeBooking: CompleteStatementBookingNavigation,
  };
  const Navigation = navigationTypes[seatFormation] || (() => <div />);

  useEffect(() => {
    if (!navigationTypes?.[seatFormation]) {
      navigate('/ka/search');
    }
  }, []);

  return (
    <div>
      <Navigation outline={outline} />
      <BookingTimer className="relative top-16" />
    </div>
  );
}

export default BookingNavigation;
